(function () {
  'use strict';

  var started = false;
  var attempts = 0;

  function initializeTimedPopup() {
    var $ = window.jQuery_T4NT;
    var popup = document.querySelector('#t4s-popup__exit');

    if (!$ || !popup || !window.T4SThemeSP || !$.magnificPopupT4s) {
      attempts += 1;
      if (attempts < 200) window.setTimeout(initializeTimedPopup, 100);
      return;
    }

    var settings = $(popup).data('stt') || {};
    if (settings.trigger !== 'time' || started || window.IsDesignMode) return;

    var cookieName = T4Sconfigs.theme + '_exit';
    if (window.CookiesT4 && CookiesT4.get(cookieName) === 'shown') return;

    started = true;
    function openWhenAvailable() {
      if ($('.mfp-content').length) {
        window.setTimeout(openWhenAvailable, 500);
        return;
      }

      $.magnificPopupT4s.open({
        items: { src: '#t4s-popup__exit' },
        type: 'inline',
        removalDelay: 500,
        tClose: window.T4SThemeSP.mfp_close,
        callbacks: {
          beforeOpen: function () {
            $('html').addClass('is-opening-mfp');
            this.st.mainClass = 'mfp-move-horizontal t4s-exit_pp_wrapper';
          },
          open: function () {
            if ($('.t4s-exit_pp_wrapper .t4s-product').length) {
              T4SThemeSP.reinitProductGridItem();
            }
            $(document.body).trigger('t4s:hideTooltip').trigger('currency:update');
          },
          close: function () {
            if (window.CookiesT4) {
              CookiesT4.set(cookieName, 'shown', {
                expires: settings.day_next,
                path: '/'
              });
            }
          },
          afterClose: function () {
            $('html').removeClass('is-opening-mfp');
          }
        }
      });
    }

    var remainingMs = Math.max(0, Number(settings.display_delay) || 0) * 1000;
    var lastTick = window.performance.now();
    var timer = window.setInterval(function () {
      var currentTick = window.performance.now();

      if (document.visibilityState === 'visible') {
        remainingMs -= currentTick - lastTick;
      }
      lastTick = currentTick;

      if (remainingMs <= 0) {
        window.clearInterval(timer);
        openWhenAvailable();
      }
    }, 100);
  }

  initializeTimedPopup();
}());
